import type { AxiosError, AxiosInstance, AxiosResponse } from "axios"
import type { CustomAxiosRequestConfig } from "./interface";
import { Toast } from "@/utils/toast";

export function setupMessageInterceptor(axiosInstance: AxiosInstance) {

    // Resposta
    axiosInstance.interceptors.response.use(

        // Sucesso 
        (response: AxiosResponse) => {
            const config = response.config as CustomAxiosRequestConfig;

            if (response.status == 201 && response.data.message && !config.skipMessage) { // Mostra uma mensagem quando retorna 201
                Toast.success(response.data.message);
            }

            return {
                ...response
            }
        },

        // Erro
        (error: AxiosError) => {

            if (error.status && error.response?.data) {

                const resError = (error.response.data as any)

                if (error.status >= 400 && error.status < 500 &&
                    !(error.status == 401 && (resError.data == "invalid_token" || (resError instanceof Blob))) &&
                    resError.data != "login_required" && resError.data != "access_denied"
                ) {
                    const resError = (error.response.data as any)
                    let message = resError.message
                    // Validações da campos
                    if (resError.errors) {
                        message += "<br></ul>";
                        Object.keys(resError.errors).forEach((index) => {
                            message += `<li>${index}: ${resError.errors[index]}</li>`
                        })
                        message += "</ul>"
                    }
                    Toast.warning(message);
                }
                if (error.status >= 500) {
                    Toast.error('Erro interno do servidor. Tente novamente mais tarde.');
                }
            }


            return Promise.reject(error);
        }
    )
}